import React, { useState, useEffect, useContext }  from 'react';
import { UserContext } from '../context/UserContext';
import { Link, useLocation } from 'react-router-dom';
import group31 from "../assets/loginPage/group-31.svg";
import homeIcon from "../assets/navigationBar/home.svg";
import joynetIcon from "../assets/navigationBar/myjoynet.svg";
import hottopicsIcon from "../assets/navigationBar/hottopics.svg";
import communityIcon from "../assets/navigationBar/mycommunity.svg";
import messagesIcon from "../assets/navigationBar/messages.svg";
import profileIcon from "../assets/navigationBar/profile.svg";
import "./css/NavigationBar.css";

/* This component is used to create a navigation bar for the website. It is used within the Layout component. */

const NavigationBar = () => {
  const location = useLocation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { userInfo } = useContext(UserContext);

  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);

    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, []);
  const isOtherUserProfile = location.pathname.startsWith('/profile/') && location.pathname !== '/profile';
  
  const renderLinks = (isMobile = false) => (
    <>
      <Link to="/" className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
        <img src={homeIcon} alt="Home" className="nav-icon" />
        {!isMobile && <span>Home</span>}
      </Link>
      <Link to="/myjoynet" className={`nav-item ${location.pathname === '/myjoynet' ? 'active' : ''}`}>
        <img src={joynetIcon} alt="My JoyNet" className="nav-icon" />
        {!isMobile && <span>My JoyNet</span>}
      </Link>
      <Link to="/hottopics" className={`nav-item ${location.pathname === '/hottopics' ? 'active' : ''}`}>
        <img src={hottopicsIcon} alt="Hot Topics" className="nav-icon" />
        {!isMobile && <span>Hot Topics</span>}
      </Link>
      <Link to="/community" className={`nav-item ${location.pathname === '/community' ? 'active' : ''}`}>
        <img src={communityIcon} alt="My Community" className="nav-icon" />
        {!isMobile && <span>Community</span>}
      </Link>
      <Link to="/messages" className={`nav-item ${location.pathname === '/messages' ? 'active' : ''}`}>
        <img src={messagesIcon} alt="Messages" className="nav-icon" />
        {!isMobile && <span>Messages</span>}
      </Link>
      <Link to="/profile" className={`nav-item ${location.pathname === '/profile' ? 'active' : ''}`}>
        {userInfo?.profilePictureUrl ? (
          <div className="profile-picture-wrapper">
            <img src={userInfo?.profilePictureUrl || profileIcon} alt="Profile" className="profile-picture" />
            <span className={`status-dot ${isOnline ? 'online' : 'offline'}`}></span>
          </div>
        ) : (
          <img src={profileIcon} alt="Profile" className="nav-icon" />
        )}
        {!isMobile && <span>Profile</span>}
      </Link>
      {isOtherUserProfile && (
        <div className="nav-item active">
          <img src={profileIcon} alt="Other's Profile" className="nav-icon" />
          {!isMobile && <span>Profile</span>}
        </div>
      )}

      {!isOnline && !isMobile && (
        <div className="offline-message">
          You are offline
        </div>
      )}
    </>
  );


  return (
    <nav className="nav-container">
      <div className="nav-desktop">
        <div className="nav-logo">
          <img src={group31} alt="JoyNet Logo" className="logo" />
          <span className="logo-text">JoyNet</span>
        </div>

        <div className="nav-links">
          {renderLinks()}
        </div>
      </div>
      <div className="nav-mobile">
        {renderLinks(true)}
      </div>
    </nav>
  );
};

export default NavigationBar;